module.exports = __webpack_public_path__ + "comoros.svg?ea4e5f332f06499ac7a461571ec57be7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/comoros.svg
// module id = 139
// module chunks = 10